import { useState } from 'react';

import Sharebar from './Sharebar'
import ScrollEffect from './ScrollEffect';

const Header = () =>{
   const [shouldHideHeader, setShouldHideHeader] = useState(false);
   
     
   const MINIMUM_SCROLL = 316;
   const TIMEOUT_DELAY = 400;

   ScrollEffect(callbackData => {
   const { previousScrollTop, currentScrollTop } = callbackData;
   const isScrolledDown = previousScrollTop < currentScrollTop;
   const isMinimumScrolled = currentScrollTop > MINIMUM_SCROLL;


   setTimeout(() => {
     setShouldHideHeader(isScrolledDown && isMinimumScrolled);
   }, TIMEOUT_DELAY);
   
   });

   const hiddenStyle = shouldHideHeader ? 'hidden' : '';

   return (
      <div className={`stuffHeader-container ${hiddenStyle}`}>
      {/* eslint-disable-next-line */}
      <a target="_blank" href="https://www.stuff.co.nz/" className="stuffHeader-container__logo" rel="noopener noreferrer"></a>
      <Sharebar />
      <div className="stuffHeader-container--rainbow"></div>
      </div>
       
     );
}

export default Header;
